import Link from "next/link";
import { ExternalLink } from "lucide-react";
import { NoxusIcon } from "./NoxusIcon";

export const getUrlForEntity = (type: string, id: string): string | null => {
  switch (type) {
    case "workflow":
      return `/flows/${id}`;
    case "assistant":
      return `/assistant/${id}`;
    case "kb":
      return `/data-hub/${id}`;
    case "inbox":
      return `/inbox/${id}`;
    case "table":
      return `/tables/${id}`;
    default:
      return null;
  }
};

export const getIconForType = (type: string): string => {
  switch (type) {
    case "workflow":
      return "workflow";
    case "assistant":
      return "coworker";
    case "kb":
      return "kb";
    case "file":
      return "file";
    case "inbox":
      return "inbox";
    case "secret":
      return "key";
    case "deployment":
      return "app-window";
    case "connection":
      return "plug";
    case "table":
      return "table";
    case "trigger":
      return "zap";
    default:
      return "workflow";
  }
};

export const getSingularLabelForType = (type: string): string => {
  switch (type) {
    case "workflow":
      return "Flow";
    case "assistant":
      return "Agent";
    case "kb":
      return "Knowledge Base";
    case "file":
      return "File";
    case "inbox":
      return "Inbox";
    case "secret":
      return "Secret";
    case "deployment":
      return "Deployment";
    case "connection":
      return "Connection";
    case "table":
      return "Table";
    case "trigger":
      return "Trigger";
    default:
      return type;
  }
};

interface IEntityReferenceRow {
  icon: string;
  // Shown instead of the icon when set.
  image?: string;
  name: string;
  typeLabel: string;
  href?: string | null;
}

export const EntityReferenceRow = ({
  icon,
  image,
  name,
  typeLabel,
  href,
}: IEntityReferenceRow) =>
  href ? (
    <Link
      href={href}
      target="_blank"
      className="flex items-center w-full gap-3 rounded-lg p-2 hover:bg-accent transition-colors text-sm font-normal hover:cursor-pointer group"
    >
      <NoxusIcon icon={icon} image={image} size="md" />
      <div className="flex flex-col">
        <span>{name}</span>
        <span className="text-xs text-muted-foreground">{typeLabel}</span>
      </div>
      <ExternalLink
        size={16}
        className="text-muted-foreground ml-auto opacity-0 group-hover:opacity-100 transition-opacity"
        strokeWidth={1.33}
      />
    </Link>
  ) : (
    <div className="flex items-center w-full gap-3 rounded-lg p-2">
      <NoxusIcon icon={icon} image={image} size="md" />
      <div className="flex flex-col">
        <span className="text-sm font-normal">{name}</span>
        <span className="text-xs text-muted-foreground">{typeLabel}</span>
      </div>
    </div>
  );
